










import Vue from 'vue';
import LogoCluba from './logo.cluba.component.vue';
import LogoMalaki from './logo.malaki.component.vue';
import LogoCoolCashStash from './logo.coolcashstash.component.vue';
import LogoTherhizomes from './logo.therhizomes.component.vue';
import LogoCoolWaterSplash from './logo.coolwatersplash.component.vue';
import LogoEmarket from './logo.emarket.component.vue';
import LogoIWatchRevenue from './logo.iwatchrevenue.component.vue';

const component = {
    data() {
        return {
            brand: process.env.VUE_APP_BRAND
        };
    },
    components: {
        'logo-cluba': LogoCluba,
        'logo-malaki': LogoMalaki,
        'logo-coolcashstash': LogoCoolCashStash,
        'logo-therhizomes': LogoTherhizomes,
        'logo-coolwatersplash': LogoCoolWaterSplash,
        'logo-emarket': LogoEmarket,
        'logo-iwatchrevenue': LogoIWatchRevenue
    }
};

export default component;
